module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Arrows-v-1ff96494b42306a94e17c53f45187387.svg";